export default __webpack_public_path__ + "static/python-web-2415d62a85e3b8da05e90420c0120729.jpg";